import { Element_Base } from '~/common/typescript/models/Element';
import MapUtils from '~/components/Map/utils/MapUtils';
import { zoomToFeature } from '~/components/Map/panels/GeocollectDatatablePanel/utils/MapHighlightUtils';
import { FeatureCollection } from '@turf/turf';

export const ElementItemUtil = {
  zoomToElement: (element: Element_Base) => {
    if (!element?.geom) return;
    try {
      const geom = typeof element.geom === 'string' ? JSON.parse(element.geom) : element.geom;
      zoomToFeature(geom);
    } catch (error) {
      console.error('Error parsing element geometry for zoom:', error);
    }
  },
  highlightElement: (element: Element_Base) => {
    if (!element?.geom) return;
    try {
      const geom = typeof element.geom === 'string' ? JSON.parse(element.geom) : element.geom;
      const featureCollection = {
        type: 'FeatureCollection',
        features: [
          {
            type: 'Feature',
            properties: {
              name: element.name,
            },
            geometry: geom,
          },
        ],
      } as FeatureCollection;

      MapUtils.highlightFeatureCollection(featureCollection);
    } catch (error) {
      console.error('Error parsing element geometry for highlight:', error);
    }
  },
};
